module.exports = __webpack_public_path__ + "static/img/换绑同身份证.bb655a5.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/换绑同身份证.png
// module id = IUS8
// module chunks = 0